// @ts-strict-ignore
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Observable, of, of as observableOf, Subscriber, Subscription } from 'rxjs';
import { SohoMessageService } from 'ids-enterprise-ng';

import { LMLoggerService } from '@services/lm-logger.service';
import { AppConstants, LMDialogButtonKey } from '@utils/app.constants';
import { LMCubeUtilService } from '@modal/cubes/lm-cube-util.service';
import { LMListTreeComponent } from './lm-list-tree.component';
import { LMListChartComponent } from './lm-list-chart.component';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { LMContextService } from '@services/lm-context.service';
import { LMListEventService, LMListSpecUtilService, LMListToolbarService, LMListUtilService } from './services/';
import { LMFormatUtilService } from '@services/utils';
import { LMUniqueIdService } from '@utils/lm-unique-id.service';
import { LMGlobalUtilService } from '@utils/lm-global-util.service';
import { LMToolbarComponent } from '@toolbar/lm-toolbar.component';
import { LMListContentBaseComponent } from './lm-list-content-base.component';
import { LMThemeService } from '@banner/lm-theme.service';
import { RelatedReportParams } from '@services/lm-relatedreport.service';
import {
  LMDimension, LMDimensionMappingResult, LMReportingBasis,
} from '@modal/cubes/lm-cubes';
import { PersonalizeParams } from '@app/services';
import { KeyedResource } from '@app/resources';
import { LMLookupComponent } from '@field/lookup';
import { LMSavedSearchService } from '@app/components';
import { LMBannerHeaderComponentRef } from '@banner/lm-banner-header-component-ref.service';
import { LMConditionUtilService } from '@app/utils';

export class LMApplySavedSearchFilterCubeEvent implements  LMCubeEvent {
  event: Event;
  eventType: LMCubeEventType;

  constructor(event: Event) {
    this.event = event;
    this.eventType = 'applysavedsearch';
  }
}

export class LMSearchAndPeriodOverrideCubeEvent implements  LMCubeEvent {
  event: Event;
  eventType: LMCubeEventType;

  constructor(event: Event) {
    this.event = event;
    this.eventType = 'filterandperiodoverride';
  }

}

export class LMExportCubeEvent implements LMCubeEvent {
  event: Event;
  eventType: LMCubeEventType;

  constructor(event: Event, eventType: LMCubeEventType) {
    this.event = event;
    this.eventType = eventType;
  }
}

export class LMCubeSaveEvent implements LMCubeEvent {
  event: Event;
  eventType: LMCubeEventType;

  constructor(event: Event, eventType: LMCubeEventType) {
    this.event = event;
    this.eventType = eventType;
  }
}

export class LMCreateReportCubeEvent implements  LMCubeEvent {
  event: Event;
  eventType: LMCubeEventType;

  constructor(event: Event, eventType: LMCubeEventType) {
    this.event = event;
    this.eventType = eventType;
  }
}

export class LMCubeSearchEvent implements LMCubeEvent {
  event: Event;
  eventType: LMCubeEventType;
  actionReference: LMBusActionReference;

  constructor(event: Event, eventType: LMCubeEventType, actionReference: LMBusActionReference) {
    this.event = event;
    this.eventType = eventType;
    this.actionReference = actionReference;
  }
}

export class LMCreateReportPersonalizationCubeEvent implements  LMCubeEvent {
  event: Event;
  eventType: LMCubeEventType;
  actionReference: LMBusActionReference;

  constructor(event: Event, eventType: LMCubeEventType, actionReference: LMBusActionReference) {
    this.event = event;
    this.eventType = eventType;
    this.actionReference = actionReference;
  }
}

@Component({
  selector:    'lm-cube-view',
  providers:   [
  LMCubeUtilService,
  LMListToolbarService,
  ],
  templateUrl: 'lm-list-cube-viewer.component.html',
  styleUrls:   [ 'lm-list-cube-viewer.component.scss' ]
  })
export class LMListCubeViewerComponent extends LMListContentBaseComponent implements LMListContentInterface, OnInit, AfterViewInit, OnDestroy {

  @Input() listUrlInfo: LMListUrlInfo;
  // error TS2610: 'listSpec' is defined as an accessor in class 'LMListContentBaseComponent'
  // @Input() listSpec: LMListSpec;
  @Input() listState: LMListState;
  @Input() listPersonalization: LMListPersonalization;
  // error TS2610: 'disabled' is defined as an accessor in class 'LMListContentBaseComponent'
  // @Input() disabled = false;

  // Dashboard panel cubes
  @Input() chartName: string;
  @Input() dimensionTree: string;
  // Dashboard panel cubes

  @Input() isDashBoardContent: boolean;

  // error TS2610: 'fromDataView' is defined as an accessor in class 'LMListContentBaseComponent'
  // @Input() fromDataView: LMDataView;

  @ViewChild('modalPlaceholder', { read: ViewContainerRef, static: true }) modalPlaceholder: ViewContainerRef;
  @ViewChild(LMListTreeComponent) listTreeComponent: LMListTreeComponent;
  @ViewChild(LMListChartComponent) listChartComponent: LMListChartComponent;
  @ViewChild(LMToolbarComponent) toolbarComponent: LMToolbarComponent;

  listTitle = '';
  displayType: string;
  orientation: SohoDataGridSelectable;
  displayChartName: string;
  toolbarButtons: Observable<Array<LMToolbarButton>>;
  chartToolbarButtons: Observable<Array<LMToolbarButton>>;
  chartTitle: string;
  periodIndex: number;

  hasFilterList: boolean;
  implementsDragAndDrop: boolean;
  showFilter: boolean;
  sortOrder: LMListSortOrder;

  private cubeComponentId: string;
  private cubeDataLoadedSub: Subscription;
  private cubeFieldChangedSub: Subscription;
  private chartToolbarButtonObserver: Subscriber<Array<LMToolbarButton>>;
  private pvPeriodToolbarButton: LMToolbarButton;

  private topDimensionMapping: Array<LMDimension>;
  private filterDimensionMapping: Array<LMDimension>;
  private dimensionMappingDrillDown: LMDimensionValues;
  private searchFormContextFields: Array<string>;
  private newTopDims = false;
  
  public screenAutomationId: string;

  get cubeHostContainerClass(): string {
    if (this.isDashBoardContent || this.listSpec.dependentList) {
      return 'lm-cube-view-host-nomargin';
    } else if (this.listSpec.busListSpec.searchForm) {
      return 'lm-cube-view-host-searchform';
    }
    return 'lm-cube-view-host';
  }
  constructor(
    protected lmBannerHeaderCompRef: LMBannerHeaderComponentRef,
    protected lmFormatUtilService: LMFormatUtilService,
    protected lmListEventService: LMListEventService,
    protected lmListSpecUtilService: LMListSpecUtilService,
    protected lmListToolbarService: LMListToolbarService,
    protected lmLoggerService: LMLoggerService,
    protected lmThemeService: LMThemeService,
    protected lmCubeUtilService: LMCubeUtilService,
    protected lmUrlUtilService: LMUrlUtilService,
    protected lmContextService: LMContextService,
    protected lmConditionUtilService: LMConditionUtilService,
    protected sohoMessageService: SohoMessageService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected lmGlobalUtilService: LMGlobalUtilService,
    protected lmListUtilService: LMListUtilService,
    protected lmSavedSearchService: LMSavedSearchService,
  ) {
    super(lmLoggerService, lmThemeService, lmFormatUtilService, lmListUtilService, lmConditionUtilService);
  }

  ngOnInit() {
    this.build();
    this.cubeDataLoadedSub =
      this.lmListEventService.cubeDataLoadedEvent$.subscribe(event => this.onDataLoaded(event));
    this.cubeFieldChangedSub =
      this.lmListEventService.fieldChangedEvent$.subscribe(event => this.onContentModified(event));
  }

  ngAfterViewInit() {
    // Default saved search can be done only in after view init
    // Initializing filter dimension mapping required for search forms here before setting default saved search
    if (this.listSpec.busListSpec.searchForm) {
      this.initializeDimensionMappingForSearch()
      .subscribe((ready) => {
        // Dimension mapping should be loaded before applying saved search
        this.applyDefaultSavedSearch();
      });
    } else {
      this.applyDefaultSavedSearch();
    }
  }

  private applyDefaultSavedSearch() {
    if (this.listState.userListViewItem?.isDefault) {
      const savedSearchState: LMSearchState = JSON.parse(this.listState.userListViewItem.searchState);
      this.cubeApplyUserListView(savedSearchState, this.listState.userListViewItem);
    }
  }

  ngOnDestroy() {
    this.cubeDataLoadedSub.unsubscribe();
    this.cubeFieldChangedSub.unsubscribe();
    this.onBeforeListToolbarMoreMenuOpen = null;
  }

  get inMingleWidget(): boolean {
    return this.lmContextService.inMingleWidget();
  }

  get hideToolbarTitles(): boolean {
    // It is used only by display type = tree, when in a list detail section.
    // Do not want to push the cube toolbar such as dimensions, period override to overflow menu in a cube viewer.
    return (this.listSpec.dependentList && !this.isDashBoardContent && !this.lmContextService.inMingleWidget()) ? false : true;
  }

  protected build() {
    this.initialize();
  }

  protected loadManualData(): void {
    // Not implemented
  }

  protected onFormButtonClicked(columnDef: ListGridColumn, dataView: LMDataView, row: any, cell: any, navigationParams: any, event: any): void {
    // Not implemented
  }

  protected fromDataViewChanged(): void {
    if (this.listSpec.dependentList) {
      // Protect against a cube list being defined with implements manual loading
      this.allowDataLoading = true;
    }
  }

  private initialize() {
    this.cubeComponentId = this.listSpec.busListSpec.id;
    this.screenAutomationId = this.listSpec.busListSpec.automationId;
    
    if (this.isDashBoardContent) {
      this.displayType = 'chart';
      if (this.chartName) {
        this.displayChartName = this.chartName;
        this.setOrientation(this.displayChartName);
      } else if (this.listSpec.busListSpec.defaultChartName) {
        this.displayChartName = this.listSpec.busListSpec.defaultChartName;
        this.setOrientation(this.displayChartName);
      } else {
        this.displayType = 'tree';
        this.orientation = 'single';
      }
    } else {
      if (this.listSpec.cubeOptions && this.listSpec.cubeOptions.chartName) {
        this.displayChartName = this.listSpec.cubeOptions.chartName;
        this.displayType = 'treeandchart';
        this.setOrientation(this.displayChartName);
      } else if (this.listSpec.busListSpec.charts && Object.keys(this.listSpec.busListSpec.charts).length > 0) {
        this.displayChartName = (this.listSpec.busListSpec.defaultChartName)
          ? this.listSpec.busListSpec.defaultChartName : Object.keys(this.listSpec.busListSpec.charts)[ 0 ];
        this.displayType = 'treeandchart';
        this.setOrientation(this.displayChartName);
      } else {
        this.displayType = 'tree';
        this.orientation = 'single';
      }
    }

    if (!this.isDashBoardContent && !this.lmContextService.inMingleWidget()) {
      // Dashboard panels in a page will not have a cube viewer toolbar. The overview navigation will take the user to the cube viewer.
      // Same with Mingle widget too.
      this.toolbarButtons = this.lmListToolbarService.getToolbarButtonsObservable();
      if (!this.listSpec.dependentList) {
        // If the cube is a dependent list (detail panel), do not clear the banner toolbar buttons.
        // If the cube viewer list is the main list, clear the banner toolbar and make use of the tree and chart toolbars.
        this.lmBannerHeaderCompRef.instance.toolbarButtons = observableOf([]);
      }
    }

    if (this.displayType === 'treeandchart') {
      this.chartToolbarButtons = new Observable<Array<LMToolbarButton>>(observer => {
        this.chartToolbarButtonObserver = observer;
      });
      this.periodIndex = 0;
      if (this.listState
        && this.listState.cubeOverrides) {
        if (this.listState.cubeOverrides.chartName
          && this.listState.cubeOverrides.chartName.length > 0) {
          this.displayChartName = this.listState.cubeOverrides.chartName;
        }
        if (this.listState.cubeOverrides.periodViewPeriod) {
          this.periodIndex = this.listState.cubeOverrides.periodViewPeriod;
        }
      }
    }
    this.dimensionMappingDrillDown = {};
    this.searchFormContextFields = [];
    if (this.listState?.filterCriteria?.length) {
      this.listState.filterCriteria.forEach(f => {
        if (f.isBusClassContextField && !f.isDisplayOnly) {
          this.searchFormContextFields.push(f.fieldId);
        }
      }, this);
    }
  }

  private setOrientation(chartName: string) {
    this.orientation = (this.listSpec.busListSpec.charts[ chartName ].orientation === 'row')
      ? 'siblings' : 'single';
  }

  private buildToolbar() {
    this.lmListToolbarService.buildToolbarButtons(this.listSpec, this.getStateInfo(), this.listUrlInfo);

    // Build Chart toolbar
    this.buildChartToolbar();
  }

  private buildChartToolbar() {
    if (this.displayType === 'treeandchart') {
      this.setChartTitle(this.displayChartName);

      this.setChartPVPeriodsToolbarButtons();
    }
  }

  private getStateInfo(): LMListStateInfo {
    // LMListStateInfo vs LMListState
    // This is used by LMListToolbarService only.
    const stateInfo: LMListStateInfo = {
      dataViewSet:          this.getDataViewSet(),
      selectedDataView:     this.getSelectedTreeDataView(),
      selectedRows:         this.getSelectedRows(),
      isModified:           this.isModified(),
      isUpdatable:          this.lmListSpecUtilService.allowUpdate(this.listSpec),
      inlineCreateEnabled:  false,
      createWithinEnabled:  false,
      cubeDisplayChartName: this.displayChartName,
      userListViewItem: this.listState.userListViewItem,
      disableSaveInUserListViewMenu: this.disableSaveInUserListViewMenu()
    };

    return stateInfo;
  }

  private setChartTitle(chartName: string) {
    const listChartTitle = this.listSpec.busListSpec.charts[ chartName ].title;
    this.chartTitle = this.lmFormatUtilService.formatMessageRule(listChartTitle, this.getDataViewSet().header);
  }

  private setChartPVPeriodsToolbarButtons(): void {
    const pvPeriodToolbar: Array<LMToolbarButton> = new Array<LMToolbarButton>();

    const hasPeriodViews = this.listSpec.cubeOptions.periods && this.listSpec.cubeOptions.periods.length > 0;
    const pvPeriods = this.getDataViewSet().cubeInfo.pvPeriods;
    if (hasPeriodViews && pvPeriods && pvPeriods.length > 0) {
      let currentPVPeriod = pvPeriods[ 0 ];
      if (this.listState.cubeOverrides && this.listState.cubeOverrides.periodViewPeriod) {
        // When the user switches period view, the index stored in state may or may not have an item.
        if (this.listState.cubeOverrides.periodViewPeriod < pvPeriods.length) {
          currentPVPeriod = pvPeriods[ this.listState.cubeOverrides.periodViewPeriod ];
        } else {
          this.listState.cubeOverrides.periodViewPeriod = undefined;
          this.periodIndex = 0;
        }
      }
      this.pvPeriodToolbarButton = this.getPeriodViewPeriodMenuItem(currentPVPeriod, true);
      this.pvPeriodToolbarButton.menu = pvPeriods.map(pvPeriod => this.getPeriodViewPeriodMenuItem(pvPeriod));
      pvPeriodToolbar.push(this.pvPeriodToolbarButton);
    }
    this.chartToolbarButtonObserver.next(pvPeriodToolbar);
  }

  private getPeriodViewPeriodMenuItem(pvPeriod: LMPeriodViewPeriod, isTopLevel = false): LMToolbarButton {
    const label = pvPeriod.label;
    const pvPeriodActionRef: LMBusActionReference = {
      id:   AppConstants.CUBE_TOOLBAR_PERIODVIEWPERIODS,
      type: 'cube', label, index: pvPeriod.idx, tooltip: Soho.Locale.translate('ChartPeriod')
    };
    const pvPeriodToolbarItem: LMToolbarButton = {
      actionReference: pvPeriodActionRef,
      state:           { visible: true, disabled: null },
      data:            JSON.stringify(pvPeriodActionRef),
      isToggle:        false,
    };
    if (!isTopLevel) {
      const currSelectionIndex = (this.listState.cubeOverrides && this.listState.cubeOverrides.periodViewPeriod)
        ? this.listState.cubeOverrides.periodViewPeriod : 0;
      if (pvPeriod.idx === currSelectionIndex) {
        pvPeriodToolbarItem.isChecked = true;
      }
    }
    return pvPeriodToolbarItem;
  }

  public onToolbarButtonEvent(toolbarButtonEvent: LMToolbarButtonEvent): void {
    this.lmLoggerService.trace([ this, this.cubeComponentId, 'onToolbarButtonEvent', toolbarButtonEvent ]);

    const actionReference: LMBusActionReference = toolbarButtonEvent.actionReference;
    this.runToolbarButtonAction(actionReference);
  }

  private runToolbarButtonAction(actionReference: LMBusActionReference, selectedDataView?: LMDataView): void {
    // Action reference type is cube for all cube related actions.
    switch (actionReference.id) {
      case AppConstants.CUBE_TOOLBAR_SET_CH_DIMENSIONS:
        this.setTopDimensionValues();
        break;
      case AppConstants.CUBE_TOOLBAR_DRILLDOWN_DIMENSIONS:
        this.drillDownDimensionTree(selectedDataView);
        break;
      case AppConstants.CUBE_TOOLBAR_SET_FILTER_DIMENSIONS:
        this.setFilterDimensionValues();
        break;
      case AppConstants.CUBE_TOOLBAR_DIMENSIONS:
        this.buildDimensionsDialog();
        break;
      case AppConstants.CUBE_TOOLBAR_PIVOTVIEWS:
        this.changePivotView(actionReference.pivotViewCommand);
        break;
      case AppConstants.CUBE_TOOLBAR_COLUMNVIEWS:
        this.changeColumnView(actionReference.columnViewCommand);
        break;
      case AppConstants.CUBE_TOOLBAR_PERIODOVERRIDE:
        this.buildPeriodOverrideDialog();
        break;
      case AppConstants.CUBE_TOOLBAR_PERIODVIEW:
        this.changePeriodView(actionReference.periodViewCommand);
        break;
      case AppConstants.STANDARD_TOOLBAR_REFRESH:
        this.refresh().subscribe();
        break;
      case AppConstants.CUBE_TOOLBAR_OPTIONS_CUBESTATUS:
        this.displayCubeStatus();
        break;
      case AppConstants.STANDARD_TOOLBAR_PRINTTOFILE:
        this.runPdfAction();
        break;
      case AppConstants.STANDARD_TOOLBAR_EXPORTCSV:
        this.runCsvAction();
        break;
      case AppConstants.STANDARD_TOOLBAR_CREATEREPORT:
        this.runCreateReport();
        break;
      // case AppConstants.STANDARD_TOOLBAR_PERSONALIZE:
      //   this.runCreateReportPersonalization(actionReference);
      //   break;
      case AppConstants.STANDARD_TOOLBAR_CHARTMENU_BUTTON:
        this.switchChart(actionReference.name);
        break;
      case AppConstants.CUBE_TOOLBAR_PERIODVIEWPERIODS:
        this.switchChartPeriodViewPeriod(actionReference.index);
        break;
      case AppConstants.STANDARD_SAVE:
        this.runCubeSaveAction();
        break;
      case AppConstants.STANDARD_TOOLBAR_RELATEDREPORT:
        // todo akila is this actionReference.relActionUrl built lazily or is it built on the server in the listSpec?
        //  it's ok if they are built on the server but only if they are called lazily retrieved. - Phillip 8/31/23
        this.lmGlobalUtilService.navigateByUrl(actionReference.relActionUrl);
        break;
      case AppConstants.STANDARD_TOOLBAR_SEARCH:
        this.openSearchForm(actionReference);
        break;
      case AppConstants.STANDARD_TOOLBAR_USERLISTVIEW:
        // Apply User list view
        this.cubeApplyUserListView(actionReference.searchState, actionReference.userListViewItem);
        break;
      case AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_SAVE:
        // Save current state in user list view
        this.saveUserListView();
        break;
      case AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_SAVEAS:
        this.saveAsUserListView();
        break;
      case AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_CLEAR:
        this.cubeClearUserListView();
        break;
      case AppConstants.STANDARD_TOOLBAR_USERLISTVIEW_MANAGE:
        this.lmSavedSearchService.openManageDialog(this.listSpec.busClassSpec.name, this.listSpec.busListSpec.name, this.listTitle,
          this.lmContextService.getActorId(), this.listSpec.userFolder ? this.listSpec.userFolder : '').subscribe();
        break;
      default:
        if (actionReference.type === 'personalize') {
          this.runCreateReportPersonalization(actionReference);
        }
    }
  }

  private cubeDisableSaveInUserListViewMenu(): boolean {
    if (this.listState?.userListViewItem) {
      try {
        const ulvState: LMSearchState = JSON.parse(this.listState.userListViewItem.searchState);
        const savedSearchState = JSON.stringify(ulvState.cubeData);
        const currentState = JSON.stringify(this.listState.cubeOverrides);
        if (savedSearchState !== currentState) {
          return false;
        }
      } catch (exception) {
        // will return true to disable save
      }
      return true;
    }
    if (this.listState?.cubeOverrides) {
      if (this.newTopDims) {
        return false;
      }
      if (this.listState.cubeOverrides.fltrDimensions?.length > 0) {
        return false;
      }
      if (this.listState.cubeOverrides.dimensionOverrides?.overrideDims
      || this.listState.cubeOverrides.periodOverrides?.overridePeriods) {
        return false;
      }
      if (this.listState.cubeOverrides.pivotView) {
        let pivotView = this.listSpec.cubeOptions.pivotViews.find((p) => p.default !== undefined && p.default);
        if (!pivotView) {
          pivotView = this.listSpec.cubeOptions.pivotViews[ 0 ];
        }
        if (this.listState.cubeOverrides.pivotView !== pivotView.name) {
          return false;
        }
      }
      if (this.listState.cubeOverrides.columnView) {
        let columnView = this.listSpec.cubeOptions.columnViews.find((c) => c.default !== undefined && c.default);
        if (!columnView) {
          columnView = this.listSpec.cubeOptions.columnViews[ 0 ];
        }
        if (this.listState.cubeOverrides.columnView !== columnView.name) {
          return false;
        }
      }
      if (this.listState.cubeOverrides.periodView
        && this.listState.cubeOverrides.periodView !== this.getDefaultPeriodView()) {
        return false;
      }
    }
    return true;
  }

  private cubeApplyUserListView(searchState: LMSearchState, userListViewItem: LMUserListViewItem) {
    if(!searchState  || !searchState.cubeData) {
      return;
    }
    // Build listState based on UserListView
    this.listState.userListViewItem = userListViewItem;

    // Just take the cube overrides and send a message to list component to build search tags
    this.listState.cubeOverrides = this.oldSearchStateToStrictType(searchState.cubeData);
    this.savedSearchReload(searchState);
  }

  private oldSearchStateToStrictType(cubeData: LMCubeOverrides): LMCubeOverrides {
    if (cubeData.topDimensions?.length > 0) {
      const topDimensions = cubeData.topDimensions as any;
      if (topDimensions[0].topDimId) {
        cubeData.topDimensions = topDimensions.map(t => {
          return {
            td: t.topDimId,
            tdV: t. topDimVal
          } as LMTopDimension;
        });
      }
    }
    if (cubeData.topContextFields?.length > 0) {
      const topContextFields = cubeData.topContextFields as any;
      if (topContextFields[0].topcFldId) {
        cubeData.topContextFields = topContextFields.map(tc => {
          return {
            tc: tc.topcFldId,
            tcV: tc.topcFldVal
          } as LMTopContextField;
        });
      }
    }
    if(cubeData.fltrDimensions?.length > 0) {
      const fltrDimensions = cubeData.fltrDimensions as any;
      if (fltrDimensions[0].fltrDimId) {
        cubeData.fltrDimensions = fltrDimensions.map(f => {
          return {
            fd: f.fltrDimId,
            fdV: f.fltrDimVal,
            fdType: f.fltrDimType,
          } as LMFilterDimension;
        });
      }
    }
    return cubeData;
  }

  private savedSearchReload(searchState: LMSearchState) {
    const emptyFilters = (searchState.filters === null && this.filterCriteria === null)
      || (searchState.filters?.length === 0 && this.filterCriteria?.length === 0);
    if (this.listSpec.busListSpec.searchForm && !emptyFilters) {
      // lm-list.component setFilterCriteria sets state based on this.filterCriteria before calling filterCriteriaChanged that executes search.
      // Keep both in sync. Setting filterCriteria will trigger cubeReload through filterCriteriaChanged
      // TODO: Send a message out to List to apply filter criteria. List will take care of rendering the search tags maintaining search form state.
      // this.filterCriteria = searchState.filters;
      this.listState.filterCriteria = searchState.filters;
      this.lmListEventService.cubeEvent(new LMApplySavedSearchFilterCubeEvent(null));
    } else {
      // This is the default filter dialog case when there are child hierarchy dimensions in business class.
      // The filter dimensions in cubeData will hold the filter values.
      this.lmLoggerService.log([ this, this.instanceId, 'LMListCubeViewerComponent - ApplyUserListView' ]);
      this.listTreeComponent.cubeReload(true);
    }
  }

  private saveUserListView() {
    const searchStateSave = {
      filters: this.filterCriteria,
      cubeData: this.listState.cubeOverrides
    };

    this.lmSavedSearchService.runSave({
      userListViewItem: this.listState.userListViewItem,
      searchState: searchStateSave,
      listSpec: this.listSpec,
      listUrlInfo: this.listUrlInfo
    }).subscribe((result: LMUserListViewResult) => {
      if (result.success) {
        this.listState.userListViewItem = result.userListViewItem;
        this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
      }
    });
  }

  private saveAsUserListView() {
    const searchStateSaveAs = {
      filters: this.filterCriteria,
      cubeData: this.listState.cubeOverrides
    };
    this.lmSavedSearchService.runSaveAs({
      name: this.listState.userListViewItem?.name,
      searchState: searchStateSaveAs,
      listSpec: this.listSpec,
      listUrlInfo: this.listUrlInfo
    }).subscribe((result: LMUserListViewResult) => {
      if (result.success) {
        this.listState.userListViewItem = result.userListViewItem;
        this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
      }
    });
  }

  private cubeClearUserListView() {
    this.listState.userListViewItem = undefined;
    if (this.listSpec.busListSpec.searchForm) {
      this.listState.filterCriteria = null;
    }

    this.listState.cubeOverrides = {};
    const emptyFilters = (this.listState.filterCriteria === null && this.filterCriteria === null)
      || (this.listState.filterCriteria?.length === 0 && this.filterCriteria?.length === 0);
    if (this.listSpec.busListSpec.searchForm && !emptyFilters) {
      // lm-list.component setFilterCriteria sets state based on this.filterCriteria before calling filterCriteriaChanged that executes search.
      // Keep both in sync. Setting filterCriteria will trigger cubeReload through filterCriteriaChanged
      // TODO: Send a message out to List to apply filter criteria. List will take care of rendering the search tags maintaining search form state.
      // this.filterCriteria = searchState.filters;
      this.lmListEventService.cubeEvent(new LMApplySavedSearchFilterCubeEvent(null));
    } else {
      this.lmLoggerService.log([ this, this.instanceId, 'LMListCubeViewerComponent - ClearUserListView' ]);
      this.listTreeComponent.cubeReload(true);
    }
  }

  private getDefaultPeriodView(): string {
    // Cube has no period views defined, return
    if (this.listSpec.cubeOptions.pCommands?.length === 0) {
      return '';
    }

    // If cube has pivot views defined, then get the current pivot to check for POBD
    let currentPivot;
    if (this.listSpec.cubeOptions.pivotViews?.length > 0) {
      if (this.listState.cubeOverrides?.pivotView) {
        currentPivot = this.listSpec.cubeOptions.pivotViews.find(p => p.name === this.listState.cubeOverrides.pivotView);
      } else {
        currentPivot = this.listSpec.cubeOptions.pivotViews.find((p) => p.default !== undefined && p.default);
        if (!currentPivot) {
          currentPivot = this.listSpec.cubeOptions.pivotViews[ 0 ];
        }
      }
    }
    // If the current pivot has POBD, then return only yearly period view
    if (currentPivot?.hasPOBD) {
      const yearly = this.listSpec.cubeOptions.yearly.findIndex(p => p === true);
      return this.listSpec.cubeOptions.pCommands[yearly];
    }

    // No pivot view, return the first period view which is the default.
    return this.listSpec.cubeOptions.pCommands[0];
  }

  private initializeTopAndFilterDimensionValues() {
    // Do it only for GL95 for now with Child hierarchy dimensions.
    // The values are set in the List state. It will be applied when the user goes to period override but does not visit the structure or filter dialogs.
    // TODO: Filter eventually will be available for all cubes. At that time initialize filter even when child hierarchy dimensions are not present.
    // TODO: This will merge the top node or filter dimension values in a saved report for cubes.
    if (this.listSpec.busListSpec.hasChildHierarchyDims) {
      if (!this.listState) {
        this.listState = {};
      }
      if (!this.listState.cubeOverrides) {
        this.listState.cubeOverrides = {};
      }

      // Initialize top dimensions and reporting basis
      if (!this.listState.cubeOverrides.topDimensions || this.listState.cubeOverrides.topDimensions.length === 0) {
        const topDimensions: Array<any> = [];
        if (this.dataViewSet?.cubeInfo.topNodeDims) {
          Object.keys(this.dataViewSet.cubeInfo.topNodeDims)
            .map((key) => {
              const value = this.dataViewSet.cubeInfo.topNodeDims[ key ];
              topDimensions.push({
                td: key,
                tdV: value,
                // Removing dimension type since all the top node dimenions are Child hierarchy dimension. It need not be in the request.
                // 'topDimType': dimension.dimType
              });
            });
          this.listState.cubeOverrides.topDimensions = topDimensions;
          this.listState.cubeOverrides.reportingBasis = this.dataViewSet.cubeInfo.reportingBasis;
        }
      }
      // Initialize ctx field value
      if (this.dataViewSet?.cubeInfo.topContextFields) {
        this.listState.cubeOverrides.topContextFields = [ ... this.dataViewSet.cubeInfo.topContextFields ];
      }

      // Initialize filter dimensions for saved search
      if ((!this.listState.cubeOverrides.fltrDimensions || this.listState.cubeOverrides.fltrDimensions.length === 0)
      && this.dataViewSet?.cubeInfo.fltrDimensions) {
        this.listState.cubeOverrides.fltrDimensions = [ ...this.dataViewSet.cubeInfo.fltrDimensions ];
      }
    }
    // If dataviewset has a pivot view name, but user did not override the default or first pivot, then add it to the state object.
    // Pivot is changed by framework when DBM dimensions are present in the column view, if the default pivot contains a DBM dimension.
    // This happens only when the cube is brought up from the menu and default pivot has a DBM dimension and does not work well
    // with default columnview with DBM dimensions.
    // Record the override in state object so the dimension dialog and report personalization will be aware of it.
    // This will show up as a change for saved search.
    if (this.dataViewSet?.cubeInfo?.pivotView) {
      const dvsPivotView = this.dataViewSet.cubeInfo.pivotView;
      if (this.listState?.cubeOverrides
        && !this.listState.cubeOverrides.pivotView) {
        this.listState.cubeOverrides.pivotView = dvsPivotView;
      }
    }
  }

  private setTopDimensionValues(): void {
    // this.topDimensionMapping is an Array of LMDimension. Output of cubeDimensionMapping that includes dimension name, type, value, selecturl etc.
    // initTopNodeValues - If the user has not clicked on structures dialog, get the name and value of top dimensions from DVS to initialize the Dimension in Structure dialog.
    const initTopNodeValues: LMDimensionValues = {};
    if (this.topDimensionMapping === undefined) {
      // Will this value be the same as top dimensions in a saved report?
      // When the user switches period view or pivot view, the dataviewset will have the correct top dimension values.
      Object.keys(this.dataViewSet.cubeInfo.topNodeDims).forEach((dim) => {
        initTopNodeValues[dim] = this.dataViewSet.cubeInfo.topNodeDims[dim].replace(/(\r\n|\n|\r)/gm, '/');
      });
    }
    // Initialize the reporting basis required in the structure dialog.
    let reportingBasis: LMReportingBasis;
    if (this.dataViewSet.cubeInfo.reportingBasis) {
      const selectResource = new KeyedResource({ resourceType: 'list', resourceId:this.dataViewSet.cubeInfo.reportingBasisBusClass + '.' + this.dataViewSet.cubeInfo.reportingBasisSelList });
      const contextResource = new KeyedResource({ resourceType: 'select', resourceId: this.dataViewSet.cubeInfo.reportingBasisBusClass + '.' + this.dataViewSet.cubeInfo.reportingBasisFieldId });
      reportingBasis = { busClass: this.dataViewSet.cubeInfo.reportingBasisBusClass,
        cubeListName: this.listSpec.busListSpec.name,
        fieldId: this.dataViewSet.cubeInfo.reportingBasisFieldId,
        label: this.dataViewSet.cubeInfo.reportingBasisLabel,
        value: this.dataViewSet.cubeInfo.reportingBasis,
        selectUrl: this.lmUrlUtilService.buildUrl({ resource: selectResource, contextResource, params: { output: 'spec', type: 'select' } })
      };
    }
    this.lmCubeUtilService.buildCubeStructuresDialog(this.modalPlaceholder, this.listSpec.busClassSpec.name, initTopNodeValues, this.topDimensionMapping, reportingBasis)
      .subscribe((response: LMDimensionMappingResult) => {
        if (response && response.dimensionMapping && response.dimensionMapping.length > 0) {
          this.topDimensionMapping = response.dimensionMapping;
          const topDimensions: Array<any> = new Array<any>();
          this.topDimensionMapping
            .filter((item: LMDimension) => item.value && item.value.trim().length)
            .map((item: LMDimension) => {
              topDimensions.push({
                td: item.id,
                tdV: item.value ? item.value.replace(/\//g, '\n') : item.value,
                // Removing dimension type since all the top node dimenions are Child hierarchy dimension. It need not be in the request.
                // 'topDimType': item.dimType
              });
            });
          let reload = false;
          if (response.reportingBasis && this.dataViewSet.cubeInfo.reportingBasis !== response.reportingBasis) {
            this.listState.cubeOverrides.reportingBasis = response.reportingBasis;
            if (this.listState.cubeOverrides.topContextFields) {
              const ctxField = this.listState.cubeOverrides.topContextFields.find(c => c.tc === this.dataViewSet.cubeInfo.reportingBasisFieldId);
              if (ctxField) {
                ctxField.tcV = response.reportingBasis;
              }
            }
            reload = true;
            // drop filter child hierarchy dimensions since they are in the context of old reporting basis/topDimensions.
            this.clearFilterDimensionValues(topDimensions, true);
            // Also remove the period override since the calendar can change with reporting basis change
            if (this.listState.cubeOverrides.periodOverrides?.overridePeriods) {
              this.listState.cubeOverrides.periodOverrides = {};
            }
          }
          if (topDimensions.length) {
            // Compare old and new top dimension value in the listState.
            // If they are not the same, then clear the corresponding filter dimension value.
            // If reload is set, the filter dimensions are already cleared (reporting basis changed)
            if (!reload) {
              this.clearFilterDimensionValues(topDimensions);
            }
            this.listState.cubeOverrides.topDimensions = topDimensions;
            reload = true;
          }
          if (reload) {
            this.newTopDims = true;
            if (this.listSpec.busListSpec.searchForm) {
              this.updateFilterCriteriaFromStructures();
            } else {
              this.lmLoggerService.log([ this, this.instanceId, 'LMListCubeViewerComponent - SetTopDimensions - ReportingBasisChanged' ]);
              this.listTreeComponent.cubeReload(true);
            }
          }
        } else if (response && response.message && response.message === 'reset') {
          // Reset in Structure dialog brings back to the first reporting basis in the list of Reporting basis.
          // The framework will fetch the top dimension values if reporting basis and top dimension values are not provided.
          this.topDimensionMapping = undefined;
          this.listState.cubeOverrides.reportingBasis = undefined;
          if (this.listState.cubeOverrides.topContextFields) {
            const ctxField = this.listState.cubeOverrides.topContextFields.findIndex(c => c.tc === this.dataViewSet.cubeInfo.reportingBasisFieldId);
            if (ctxField !== -1) {
              this.listState.cubeOverrides.topContextFields.splice(ctxField, 1);
            }
          }
          // drop filter hierarchy dimensions since they are in the context of the reporting basis/topDimensions.
          this.clearFilterDimensionValues(this.listState.cubeOverrides.topDimensions, true);
          this.listState.cubeOverrides.topDimensions = [];
          this.newTopDims = false;
          if (this.listSpec.busListSpec.searchForm) {
            this.updateFilterCriteriaFromStructures();
          } else {
            this.lmLoggerService.log([ this, this.instanceId, 'LMListCubeViewerComponent - SetTopDimensions' ]);
            this.listTreeComponent.cubeReload(true);
          }
        }
      });
  }

  private clearFilterDimensionValues(topDimensions: Array<any>, all = false) {
    const listState = this.listState;
    topDimensions.forEach((newTopD) => {
      if (all) {
        this.clearAFilterDimension(newTopD.td);
      } else {
        const oldTopD = listState.cubeOverrides.topDimensions.find(topD => topD.td === newTopD.td);
        if (oldTopD && oldTopD.tdV !== newTopD.tdV) {
          // Remove the corresponding filter dimension value. The top node value has changed and is no longer valid.
          this.clearAFilterDimension(newTopD.td);
        }
      }
    });
  }
  private clearAFilterDimension(fltrDimId: string) {
    if (this.listState?.cubeOverrides?.fltrDimensions?.length) {
      const index = this.listState.cubeOverrides.fltrDimensions.findIndex(fltrD => fltrD.fd === fltrDimId);
      if (index !== -1) {
        this.listState.cubeOverrides.fltrDimensions.splice(index, 1);
      }
    }
    if (this.filterDimensionMapping) {
      const index2 = this.filterDimensionMapping.findIndex(f => f.id === fltrDimId);
      if (index2 !== -1) {
        this.filterDimensionMapping[index2].value = '';
      }
    }
  }

  private updateFilterCriteriaFromStructures() {
    // This will be called when there is a search form
    // and when the reporting basis and top dimensions change in structures dialog.
    this.syncFilterCriteriaAndFilterMapping();

    const filterCriterion = this.listState.filterCriteria.find(f => f.fieldId === this.dataViewSet.cubeInfo.reportingBasisFieldId);
    if (filterCriterion) {
      filterCriterion.value = this.listState.cubeOverrides.reportingBasis;
      filterCriterion.displayValue = this.listState.cubeOverrides.reportingBasis;
    }
    // Let the list component handle search. The filter criteria and tags will all be updated and filterCriteriaChanged will do cube reload.
    this.lmListEventService.cubeEvent(new LMApplySavedSearchFilterCubeEvent(null));
    return;
  }

  private setFilterDimensionValues(): void {
    const initFilterValues = this.initializeFilterState();
    // Pass DVS top dimension values (base values) to initialize the select dataview appropriately. The select window will
    // show only the top node and its children as a result.
    const topNodeBaseValues: LMDimensionValues = this.getTopNodeBaseValues();

    this.lmCubeUtilService.buildCubeDimensionMappingDialog(this.modalPlaceholder, this.listSpec.busClassSpec.name,
      topNodeBaseValues, initFilterValues, this.filterDimensionMapping)
      .subscribe((response: LMDimensionMappingResult) => {
        if (response && response.dimensionMapping && response.dimensionMapping.length > 0) {
          this.filterDimensionMapping = response.dimensionMapping;
          const fltrDimensions: Array<any> = new Array<any>();
          this.filterDimensionMapping
            .filter((item: LMDimension) => item.value && item.value.trim().length)
            .map((item: LMDimension) => {
              fltrDimensions.push({
                fd: item.id,
                fdV: item.value ? item.value.replace(/\//g, '\n') : item.value,
                fdType: item.dimType });
            });
          if (fltrDimensions.length) {
            this.listState.cubeOverrides.fltrDimensions = fltrDimensions;
            this.lmLoggerService.log([ this, this.instanceId, 'LMListCubeViewerComponent - SetFilterDimensions' ]);
            this.listTreeComponent.cubeReload();
          }
        } else if (response && response.message && response.message === 'reset') {
          this.listState.cubeOverrides.fltrDimensions = undefined;
          if (this.filterDimensionMapping) {
            this.filterDimensionMapping.forEach((dim) => { dim.value = ''; });
          }
          // Drill down will also add filters. Reset will clear the drill down filters also.
          if (Object.keys(this.dimensionMappingDrillDown).length > 0) {
            this.dimensionMappingDrillDown = {};
          }
          this.lmLoggerService.log([ this, this.instanceId, 'LMListCubeViewerComponent - SetFilterDimensions - Reset' ]);
          this.listTreeComponent.cubeReload();
        }
      });
  }

  private initializeFilterState(): LMDimensionValues {
    const initFilterValues: LMDimensionValues = {};
    if (this.filterDimensionMapping === undefined) {
      // Check if there are values in the state and apply. This will happen when user changes the period view or pivot view.
      if (this.listState?.cubeOverrides?.fltrDimensions && this.listState.cubeOverrides.fltrDimensions.length > 0) {
        this.listState.cubeOverrides.fltrDimensions.forEach((dim) => {
          initFilterValues[dim.fd] = dim.fdV.replace(/(\r\n|\n|\r)/gm, '/');
        });
      }
    }
    return initFilterValues;
  }

  private getTopNodeBaseValues(): LMDimensionValues {
    const topNodeBaseValues: LMDimensionValues = {};
    if (this.dataViewSet.cubeInfo.topNodeDims) {
      // Will this value be the same as top dimensions in a saved report?
      // When the user switches period view or pivot view, the dataviewset will have the correct top dimension values.
      Object.keys(this.dataViewSet.cubeInfo.topNodeDims).forEach((dim) => {
        // topNodeBaseValues[dim] = this.dataViewSet.cubeInfo.topNodeDims[dim].substr(this.dataViewSet.cubeInfo.topNodeDims[dim].lastIndexOf('\n') + 1);
        topNodeBaseValues[dim] = this.dataViewSet.cubeInfo.topNodeDims[dim].replace(/(\r\n|\n|\r)/gm, '/');
      });
    }
    return topNodeBaseValues;
  }

  private drillDownDimensionTree(selectedDataView: LMDataView): void {
    // Get the dimension mapping and save it for bringing up the dialog.
    if (selectedDataView) {
      this.initializeDimensionMappingForDrillDown().subscribe((ready) => {
        // get the cube info of selected dataview and populate the filter dimensions
        // Following two member variables are used by filter dialog
        // dimensionMappingDrillDown will have the name / value of dimension. Initialize it here based on the current dimensions in selected row's cubeInfo.
        // filterDimensionMapping - This is the result of backend call to get the BusClass dimensions. It has type information and selectUrl etc to render the filter dialog.
        this.dimensionMappingDrillDown = {};
        // fltrDimensions - Used by drill down operation
        let fltrDimensions: Array<any> = new Array<any>();
        selectedDataView.cubeInfo.dimensions.forEach((dim) => {
          this.dimensionMappingDrillDown[dim.dd] = dim.ddV.replace(/(\r\n|\n|\r)/gm, '/');
          fltrDimensions.push({
            fd: dim.dd,
            fdV: dim.ddV,
            fdType: dim.ddType });
        });
        // Do not have to prompt the dialog. Just update the dimension mapping drill down and it can be used to initialize the filter dialog.
        // this.setFilterDimensionValues();

        // LMCLIENT-37438 - Merge with what is in filter dimensions already. The above block of code where fltrDimensions is built will be used if the user has not visited filter dialog.
        if (this.filterDimensionMapping && this.filterDimensionMapping.length > 0) {
          fltrDimensions = [];
          this.filterDimensionMapping.forEach((dim) => {
            // Get the value from the selected dataview or use what is already picked up in Filter dialog
            if (this.dimensionMappingDrillDown.hasOwnProperty(dim.id)) {
              dim.value = this.dimensionMappingDrillDown[dim.id];
            }
            if (dim.value.trim().length > 0) {
              fltrDimensions.push({
                fd: dim.id,
                fdV: dim.value ? dim.value.replace(/\//g, '\n') : dim.value,
                fdType: dim.dimType });
            }
          });
        }
        // Update list state filter criteria used in search forms
        // Search button will be rendered in toolbar and not filter button.
        // Search form may be open. If the row dimension field is in the search form, update the value.
        if (this.listSpec.busListSpec.searchForm) {
          this.updateFilterCriteriaAfterDrillDown();
          // Let the list component handle search. The filter criteria and tags will all be updated and filterCriteriaChanged will do cube reload.
          this.lmListEventService.cubeEvent(new LMApplySavedSearchFilterCubeEvent(null));
          return;
        }

        if (fltrDimensions.length) {
          this.listState.cubeOverrides.fltrDimensions = fltrDimensions;
          this.lmLoggerService.log([ this, this.instanceId, 'LMListCubeViewerComponent - drillDownDimensionsTree' ]);
          this.listTreeComponent.cubeReload();
        }
      });
    }
  }

  private initializeDimensionMappingForDrillDown(): Observable<boolean> {
    // Filter Mapping is required to be filled out if a search form is available.
    // This is to fetch the labels for the dimensions in search tags.
    // Other information can be picked up from rowDimensions in selected Dataview.
    // Do this before Drill down reloads the cube, since onDataLoaded will update the searchDataView
    // bound to the search form.
    if (this.listSpec.busListSpec.searchForm) {
      return this.initializeDimensionMappingForSearch();
    } else {
      return of(true);
    }
  }
  private updateFilterCriteriaAfterDrillDown() {
    this.syncFilterCriteriaAndFilterMapping();
  }

  private syncFilterCriteriaAndFilterMapping() {
    // The filter dimension mapping, if not available will be retrieved and initialized with values in listState for filter dimensions.
    // Retrieving filter dimension mapping is necessary since label for a dimension is required to be displayed in tags.
    if (!this.listState.filterCriteria) {
      this.listState.filterCriteria = [];
    }
    this.filterDimensionMapping.forEach((dim) => {
      let filterCriterion = this.listState.filterCriteria.find(f => f.fieldId === dim.encId);
      if (dim.value.trim().length > 0) {
        // Get the filter criteria from state. If a dimension is in filter criteria, update its value to row dimension value.
        // Else add a criterion to the collection. The other filter criteria in the search form will still apply
        // as the row dimension values are merged.
        if (filterCriterion) {
          filterCriterion.value = dim.value.trim();
        } else {
          filterCriterion = { fieldId: dim.encId,
            operator: 'equals',
            value: dim.value.trim(),
            displayValue: dim.value.trim(),
            label: dim.label,
          };
          this.listState.filterCriteria.push(filterCriterion);
        }
      } else {
        // This will come in play if reporting basis changed and as a result a top node is changed that its filter value is cleared.
        // In that case, remove the filter criterion from the array.
        if (filterCriterion) {
          const index = this.listState.filterCriteria.findIndex(f => f.fieldId === dim.encId);
          this.listState.filterCriteria.splice(index, 1);
        }
      }
    });
  }
  private buildDimensionsDialog(): void {
    this.lmCubeUtilService.openCubeDimensionsDialog(this.listSpec, this.dataViewSet, this.listState, this.modalPlaceholder).subscribe((result: boolean) => {
      if (result) {
        // reload list.
        this.lmLoggerService.log([ this, this.instanceId, 'LMListCubeViewerComponent - Change Dimensions' ]);
        this.listTreeComponent.cubeReload();
      }
    });
  }

  private buildPeriodOverrideDialog(): void {
    this.lmCubeUtilService.openCubePeriodOverrideDialog(this.listSpec, this.dataViewSet, this.listState, this.modalPlaceholder).subscribe((result: boolean) => {
      if (result) {
        // reload list.
        this.lmLoggerService.log([ this, this.instanceId, 'LMListCubeViewerComponent - Change Current Period' ]);
        const emptyFilters = this.filterCriteria === null || this.filterCriteria?.length === 0;
        if (this.listSpec.busListSpec.searchForm && emptyFilters) {
          // Check if filter criteria is entered in search form, but the user has not searched before overriding the period
          this.lmListEventService.cubeEvent(new LMSearchAndPeriodOverrideCubeEvent(null));
        } else {
          this.listTreeComponent.cubeReload(true);
        }
      }
    });
  }

  private changePivotView(pivotView: string) {
    this.listState.cubeOverrides = this.listState.cubeOverrides || {};
    // If dimensionOverrides are present, remove them from cubeOverrides.
    // Changing to a different pivot view will apply all but dimension override.
    // The resulting cube will have the row dimensions for the given pivot view.
    if (this.listState.cubeOverrides.dimensionOverrides?.dimensionsOverride) {
      delete this.listState.cubeOverrides.dimensionOverrides.dimensionsOverride;
    }
    this.listState.cubeOverrides.pivotView = pivotView;
    // If the pivot view has POBD, then the group and column labels will change
    // Always call reload with update column headers set to true if one of the pivot has POBD
    const cubeHasPivotsWithPOBD = this.listSpec.cubeOptions.pivotViews.filter(p => p.hasPOBD);
    // Also, if the current pivot has POBD, then switch to period view with yearly operators only.
    const currentPivot = this.listSpec.cubeOptions.pivotViews.find(p => p.name === pivotView);
    if (currentPivot?.hasPOBD && this.listSpec.cubeOptions.periods?.length > 0) {
      const periodIndex = (this.listState.cubeOverrides.periodView) ? this.listSpec.cubeOptions.pCommands.findIndex(p => p === this.listState.cubeOverrides.periodView) : 0;
      if (!this.listSpec.cubeOptions.yearly[periodIndex]) {
        const yearly = this.listSpec.cubeOptions.yearly.findIndex(p => p === true);
        this.listState.cubeOverrides.periodView = this.listSpec.cubeOptions.pCommands[yearly];
      }
    }
    this.lmLoggerService.log([ this, this.instanceId, 'LMListCubeViewerComponent - Change Pivot: ', pivotView ]);
    this.listTreeComponent.cubeReload(cubeHasPivotsWithPOBD.length > 0);
    // Dataviewset json will be used to set the current pivot view in lm-list-toolbar.service after data is loaded
  }

  private changeColumnView(columnView: string, applySavedSeach = false) {
    this.listState.cubeOverrides = this.listState.cubeOverrides || {};
    this.listState.cubeOverrides.columnView = columnView;
    // Changes the display fields. Fetch the new busListSpec.
    this.lmLoggerService.log([ this, this.instanceId, 'LMListCubeViewerComponent - Change Column View: ', columnView ]);
    this.listTreeComponent.cubeReload(true);
  }

  private changePeriodView(pCommand: string, applySavedSeach = false): void {
    if (this.chartToolbarButtonObserver) {
      this.chartToolbarButtonObserver.next([]);
    }
    this.listState.cubeOverrides = this.listState.cubeOverrides || {};
    this.listState.cubeOverrides.periodView = pCommand;
    if (this.listState.cubeOverrides.periodViewPeriod !== undefined) {
      this.listState.cubeOverrides.periodViewPeriod = 0;
    }
    // Can't do cubeReload since busListSpec changes
    this.lmLoggerService.log([ this, this.instanceId, 'LMListCubeViewerComponent - Change Period View: ', pCommand ]);
    this.listTreeComponent.cubeReload(true);
  }

  private displayCubeStatus(): void {
    let cubeStatusText = Soho.Locale.translate('CubeUnableToDetermineStatus');
    if (this.dataViewSet.cubeInfo.cubeStatus) {
      cubeStatusText = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('CubeLastRefreshText'),
        this.lmFormatUtilService.timestampToDisplay(this.dataViewSet.cubeInfo.cubeStatus));
    }

    const dialogId = 'CheckCubeStatus';
    const buttons = [
      // tslint:disable-next-line - shadowed variable e
      {
        id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.CLOSE ]),
        text: Soho.Locale.translate(LMDialogButtonKey.CLOSE),
        click: (e, modal) => {
          modal.close();
        }
      }
    ];
    this.sohoMessageService
      .message()
      .message(cubeStatusText)
      .title(Soho.Locale.translate(dialogId))
      .buttons(buttons)
      .open();
  }

  private runPdfAction() {
    this.lmListEventService.cubeEvent(new LMExportCubeEvent(null, 'exporttopdf'));
  }

  private runCsvAction() {
    this.lmListEventService.cubeEvent(new LMExportCubeEvent(null, 'exporttocsv'));
  }

  private runCreateReport() {
    this.lmListEventService.cubeEvent(new LMCreateReportCubeEvent(null, 'createreport'));
  }

  private runCreateReportPersonalization(actionReference: LMBusActionReference) {
    this.lmListEventService.cubeEvent(new LMCreateReportPersonalizationCubeEvent(null, 'createreportpersonalization', actionReference));
  }

  private runCubeSaveAction() {
    this.lmListEventService.cubeEvent(new LMCubeSaveEvent(null, 'cubesave'));
  }

  private openSearchForm(actionReference: LMBusActionReference) {
    this.initializeDimensionMappingForSearch()
      .subscribe((ready) => {
        if (ready) {
          this.lmListEventService.cubeEvent(new LMCubeSearchEvent(null, 'cubesearch', actionReference));
        }
      });
  }

  public cubeSearchOpenLookup(field: LMLookupComponent, searchFormDataView: LMDataView) {
    const topNodeBaseValues: LMDimensionValues = this.getTopNodeBaseValues();
    // Open lookup dialog component for cube views.
    // The field may be a context field and hence not in the dimension collection.
    this.initializeDimensionMappingForSearch()
      .subscribe((ready) => {
        if (ready) {
          const dimension = this.filterDimensionMapping.find(d => d.encId === field.bindId);
          const topNodeDimValue = (dimension) ? topNodeBaseValues[dimension.id] : '';
          this.lmCubeUtilService.cubeSearchOpenSelectListDialog(dimension, topNodeDimValue, field, searchFormDataView);
        }
      });
    // });
  }

  private initializeDimensionMappingForSearch(): Observable<boolean> {
    if (this.filterDimensionMapping) {
      return of(true);
    }
    return new Observable<boolean>((observer) => {
      const initFilterValues = this.initializeFilterState();

      this.lmCubeUtilService.getDimensionMapping(this.listSpec.busClassSpec.name, initFilterValues, this.filterDimensionMapping)
        .subscribe((dimMappingResult: LMDimensionMappingResult) => {
          this.filterDimensionMapping = dimMappingResult.dimensionMapping;
          observer.next(true);
          observer.complete();
        });
    });
  }

  private cubeSearchOrClearButtonClicked() {
    const fltrDimensions = [];
    const ctxFields = [];
    // Start with a clean slate and set the values based on filter criteria for search/clear/remove a search tag
    if (this.filterDimensionMapping) {
      this.filterDimensionMapping.forEach(f => { f.value = ''; });
    }
    if (this.filterCriteria?.length > 0) {
      this.filterCriteria.forEach((f) => {
        if (this.filterDimensionMapping) {
          const index2 = this.filterDimensionMapping.findIndex(fd => fd.encId === f.fieldId);
          if (index2 !== -1) {
            if (Array.isArray(f.value) && f.value.length > 0) {
              this.filterDimensionMapping[index2].value = f.value[0];
              fltrDimensions.push({
                fd: this.filterDimensionMapping[ index2 ].id,
                fdV: this.filterDimensionMapping[ index2 ].value.replace(/\//g, '\n'),
                fdType: this.filterDimensionMapping[ index2 ].dimType
              });
            } else {
              // Check for empty value. The merge that happens with sticky filterOperators in list component is introducing blank entries in filterCriteria
              if (f.value.trim().length > 0) {
                this.filterDimensionMapping[index2].value = f.value;
                fltrDimensions.push({
                  fd: this.filterDimensionMapping[ index2 ].id,
                  fdV: this.filterDimensionMapping[ index2 ].value.replace(/\//g, '\n'),
                  fdType: this.filterDimensionMapping[ index2 ].dimType
                });
              }
            }
          } else {
            // Context fields such as BudgetIdentifier
            if (!f.isDisplayOnly) {
              ctxFields[f.fieldId] = f.value;
              // ContextFields in cube is a collection of top dimension context fields in the parent link of 'top node is..' definition.
              // It also includes business class context fields in search form definition.
              // Adding it to a collection, so clear search will clear only the context fields in search form.
              if (!this.searchFormContextFields.includes(f.fieldId)) {
                this.searchFormContextFields.push(f.fieldId);
              }
            }
          }
        }
      });
    }
    // Filter dimensions may be an empty array on clear.
    if (!this.listState.cubeOverrides) {
      this.listState.cubeOverrides = {};
    }
    this.listState.cubeOverrides.fltrDimensions = fltrDimensions;
    if (!this.listState.cubeOverrides.topContextFields) {
      this.listState.cubeOverrides.topContextFields = [];
    }
    this.searchFormContextFields.forEach((fieldId: string) => {
      const cIndex = this.listState.cubeOverrides.topContextFields.findIndex(c => c.tc === fieldId);
      if (ctxFields.hasOwnProperty(fieldId)) {
        // include the value for search
        if (cIndex !== -1 ) {
          this.listState.cubeOverrides.topContextFields[cIndex].tcV = ctxFields[fieldId];
        } else {
          this.listState.cubeOverrides.topContextFields.push( { tc: fieldId, tcV: ctxFields[fieldId] });
        }
      } else {
        // clear the value for search
        if (cIndex !== -1) {
          this.listState.cubeOverrides.topContextFields.splice(cIndex, 1);
        }
      }
    }, this);
    this.lmLoggerService.log([ this, this.instanceId, 'LMListCubeViewerComponent - CubeSearchForm' ]);
    this.listTreeComponent.cubeReload(true);
  }

  private switchChart(chartName: string) {
    this.displayChartName = chartName;
    this.setOrientation(this.displayChartName);
    this.listState.cubeOverrides = this.listState.cubeOverrides || {};
    this.listState.cubeOverrides.chartName = chartName;

    this.setChartTitle(chartName);
    // Update toolbar is required if the chart toolbar uses chart title instead of icon.
    // this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo());
    if (this.listTreeComponent) {
      this.listTreeComponent.updateChartOrientationForCube();
    }
  }

  private switchChartPeriodViewPeriod(periodIndex: number) {
    this.listState.cubeOverrides = this.listState.cubeOverrides || {};
    this.listState.cubeOverrides.periodViewPeriod = periodIndex;

    this.pvPeriodToolbarButton.actionReference.label = this.getDataViewSet().cubeInfo.pvPeriods[ periodIndex ].label;
    this.periodIndex = periodIndex;
  }

  public onContentModified(fieldChangedEvent: LMListFieldChangedEvent) {
    this.lmListToolbarService.updateToolbar(this.listSpec, this.getStateInfo(), this.listUrlInfo);
  }

  public onDataLoaded(listPagingResponse: LMListPagingResponse) {
    // dataLoaded still need to be emitted so the list visibility is not set to hidden
    if (listPagingResponse.dataViewSet) {
      this.dataViewSet = listPagingResponse.dataViewSet;
      this.initializeTopAndFilterDimensionValues();
      if (!this.isDashBoardContent && !this.lmContextService.inMingleWidget()) {
        this.buildToolbar();
      }
    }
    // Set the title for cube view in a detail section.
    if (!this.hideToolbarTitles) {
      this.setScreenTitle((listPagingResponse.dataViewSet) ? listPagingResponse.dataViewSet.header : undefined);
    }
    this.lmListEventService.dataLoadedEvent(listPagingResponse);
  }

  private setScreenTitle(dataView?: LMDataView) {
    if (this.disabled) {
      const hasNoVariables = (!this.listSpec.busListSpec.title.variables || this.listSpec.busListSpec.title.variables.length === 0);
      this.listTitle = hasNoVariables ? this.listSpec.busListSpec.title.resourceValue : ' ' ;
    } else {
      this.listTitle = dataView
        ? this.lmFormatUtilService.formatMessageRule(this.listSpec.busListSpec.title, dataView)
        : this.listSpec.busListSpec.title.resourceValue;
    }
  }

  public onCubeRowsSelected(dataViewSet: LMDataViewSet | LMDataView) {
    if (this.displayType === 'treeandchart') {
      this.listChartComponent.cubeUpdateChart(dataViewSet);
    }
  }

  public onCubeListSpecUpdated(listSpec: LMListSpec) {
    // After changing top dimension value or current period or pobd pivot or period view or column view, the list display fields will change.
    // Only change in the list spec is the display fields. Update the list spec of cube viewer and chart.
    // Chart will lookup the listspec field to render. It has to be present in the collection.
    // Cube drill and navigation on fields will also use the display field for 'additional filter' information.
    this.listSpec = listSpec;
    if (this.displayType === 'treeandchart') {
      this.listChartComponent.listSpec = listSpec;
    }
  }

  public getSelectedTreeDataView(): LMListDataView {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      return this.listTreeComponent.getSelectedTreeDataView();
    }
    return null;
  }

  public clearDirty() {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      return this.listTreeComponent.clearDirty();
    }
  }

  protected filterCriteriaChanged(): void {
    if ((this.displayType === 'treeandchart' || this.displayType === 'tree') && this.listTreeComponent) {
      this.cubeSearchOrClearButtonClicked();
    }
  }

  protected filterListCriteriaChanged(): void {
    //
  }

  // Begin LMListContentInterface

  public onContextMenuItemSelected(actionReference: LMBusActionReference, selectedDataView?: LMDataView): void {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      this.runToolbarButtonAction(actionReference, selectedDataView);
    }
  }

  public updateDataViewTransaction(key: number, status: string, message: string): void {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      this.listTreeComponent.updateDataViewTransaction(key, status, message);
    }
  }

  public updateDataView(key: number, dataView: LMDataView) {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      this.listTreeComponent.updateDataView(key, dataView);
    }
  }

  public setDirtyIndicator(row: number, cell: number, showDirty: boolean) {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      this.listTreeComponent.setDirtyIndicator(row, cell, showDirty);
    }
  }

  public getDataViewSet(): LMDataViewSet {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      return this.listTreeComponent.getDataViewSet();
    }
    // Else for dashboard, just return the main dataviewset.
    return this.dataViewSet;
  }

  public getDirtyRows(commitEdits: boolean = undefined): Array<LMDataView> {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      return this.listTreeComponent.getDirtyRows(commitEdits);
    }
    return [];
  }

  public getSelectedRows(): Array<number> {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      return this.listTreeComponent.getSelectedRows();
    }
    // Else for dashboard, return empty array
    return [];
  }

  public getSelectedRow(): number {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      return this.listTreeComponent.getSelectedRow();
    }
    // Else for dashboard
    return 0;
  }

  setSelectedRows(rowsToSelect: Array<number>, scrollIntoView?: boolean) {
    // TODO:
    if (!this.isDashBoardContent) {
      if (rowsToSelect.length > 0) {
        this.listTreeComponent.cubeSelectRows(rowsToSelect, scrollIntoView);
      } else {
        // No data, zero rows to select.
        // Say, on reset period override, there is no data available.
        // If the chart was up for a different period,
        // clear the chart that belongs to a different period.
        if (this.displayType === 'treeandchart') {
          // sohoxi selectRow for tree does not trigger events if there are no rows to select (empty dataviewset)
          // In that case, listTreeComponent onRowsSelected will not be called either. Clear the chart here.
          this.listChartComponent.cubeUpdateChart(this.dataViewSet);
        }
      }
    }
  }

  public unSelectAllRows(): void {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      this.listTreeComponent.unSelectAllRows();
    }
  }

  public activateRow(row: number, scrollIntoView?: boolean): void {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      this.listTreeComponent.activateRow(row, scrollIntoView);
    }
  }

  public activatedRow(): number {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      return this.listTreeComponent.activatedRow();
    }
    return -1;
  }

  public isModified(): boolean {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      return this.listTreeComponent.isModified();
    }
    return false;
  }

  public refresh(): Observable<any> {
    if (this.displayType === 'treeandchart' || this.displayType === 'tree') {
      return this.listTreeComponent.refresh();
    }
    return of(false);
  }

  public addDataView(inlineCreateDataVie: LMDataView, row: number) {
    // TODO:
  }

  public removeDataView(row: number) {
    // TODO:
  }

  public disableSaveInUserListViewMenu(): boolean {
    return this.cubeDisableSaveInUserListViewMenu();
  }

  public clearUserListView() {
    this.cubeClearUserListView();
  }

  // End LMListContentInterface

  public get toolbarId(): string {
    if (!this.listSpec) {
      return null;
    }
    return this.listSpec.busListSpec.id + '_toolbar';
  }

  public get chartToolbarId(): string {
    if (!this.listSpec) {
      return null;
    }
    return this.listSpec.busListSpec.id + '_chart_toolbar';
  }

  onBeforeListToolbarMoreMenuOpen = (response: SohoPopupMenuResponseFunction, options: any) => {
    // -----------------------------------------------------------------------------------------
    // if a submenu, then need all the buttons for flex toolbar. This is because a menu button
    // could get overflowed and since it was in the buttonset, it wasn't in the flexMoreButtons
    // -----------------------------------------------------------------------------------------
    const buttons = options.isSubmenu ? this.toolbarComponent.flexButtons : this.toolbarComponent.flexMoreButtons;

    if (options.hasOwnProperty('contextElement')) {
      const relatedReportParams: RelatedReportParams = {
        sourceResourceUrl: this.listUrlInfo.relatedReportSourceUrl,
        listTitle: this.listTitle
      };
      const personalizeParams: PersonalizeParams = {
        sourceResourceUrl: this.listUrlInfo.reportPersonalizationUrl
      };
      const userListViewParams: UserListViewMenuParams = {
        userListViewUrl: this.lmUrlUtilService.buildUserListViewFetchUrl(this.listUrlInfo, this.listSpec),
        appliedUserListView: this.listState.userListViewItem?.userListView,
        disableSave: this.disableSaveInUserListViewMenu(),
      };
      let relatedActionsFunction: (response: AjaxBeforeOpenResponseFunction, options: any) => void;
      if (this.toolbarComponent) {
        relatedActionsFunction = this.toolbarComponent.onBeforeRelatedActionsOpen;
      } else if (this.lmBannerHeaderCompRef.instance.lmToolbarComponent) {
        relatedActionsFunction = this.lmBannerHeaderCompRef.instance.lmToolbarComponent.onBeforeRelatedActionsOpen;
      }

      this.lmListToolbarService.buildMoreButtonMenu(this.listSpec, response, options, buttons,
        { showDrillAround: false, isContextMenu: false, personalizeParams, relatedReportParams, userListViewParams }, relatedActionsFunction);
    } else {
      const responseString = this.lmListToolbarService.buildFirstLevelMoreMenu(this.listSpec, buttons, false);
      response(responseString);
    }
  };

  public toolbarMoreMenuSettings: SohoPopupMenuOptions = {
    beforeOpen: this.onBeforeListToolbarMoreMenuOpen,
    attachToBody: true
  };
}
